export default __webpack_public_path__ + "static/media/Imagem7 1.810b0117.svg";